import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RetencionesMasivasFilesActions = (props) => {
  return (
    <>
      {Guardian.allows('retencion.masiva.subir.archivo') && (
        <Button
          as={Link}
          className="mr-2"
          to="/modulos/retenciones-masivas/files/upload"
        >
          Subir archivo
        </Button>
      )}

      <Button
        variant="link"
        as={Link}
        className="text-secondary"
        to="/modulos/retenciones-masivas/tickets"
      >
        Tickets <FontAwesomeIcon icon={['fas', 'chevron-right']} />
      </Button>
    </>
  );
};

export default RetencionesMasivasFilesActions;
